import { NavigationGuardNext, Route } from 'vue-router'

function checkImpersonateGuard(to: Route, from: Route, next: NavigationGuardNext): void {
  if (to.query?.from === 'tablet' && to.name !== 'coming-soon') {
    return next({ name: 'coming-soon', query: to.query })
  }

  return next()
}

export default checkImpersonateGuard
